
<template>
    <div id="guestSetupModal" tabindex="-1" aria-hidden="true"
        class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative w-full max-w-5xl max-h-full">
            <!-- Modal content -->
            <div class="relative bg-white rounded-lg shadow">
                <!-- Modal header -->
                <div class="flex items-start justify-between p-5 border-b rounded-t">
                    <h3 class="text-xl font-semibold text-gray-900 lg:text-2xl">
                        {{ $t('Rooms setup') }}
                    </h3>
                    <button id="closeButton" @click="reset" data-modal-hide="guestSetupModal" type="button"
                        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clip-rule="evenodd"></path>
                        </svg>
                    </button>
                </div>
                <!-- Modal body -->
                <div class="p-6 space-y-6">
                    <div>
                        <div class="mb-4 border p-5 rounded-lg flex justify-between">
                            <div>
                                <span class="text-lg">{{ $t('Total') }} {{ num_adult_temp }} {{ $tc('adult', num_adult_temp)
                                }}</span>
                                <span v-if="num_children_temp" class="text-lg">{{ $t('and') }} {{ num_children_temp }} {{
                                    $tc('child',
                                        num_children_temp)
                                }}</span>
                            </div>
                        </div>
                        <ul class="grid w-full gap-4 md:grid-cols-2"
                            :class="{ 'lg:grid-cols-3': Object.keys(assigned_temp).length > 2 }">
                            <template v-for="( amount, key ) in assigned_temp ">
                                <li v-if="JSON.parse(rooms)[key]">
                                    <div class="border rounded-lg flex flex-col items-center justify-between w-full pb-2 h-full">
                                        <div class="w-full block p-5 pb-0"
                                            :class="{ 'pt-3 pb-2': getOccurrence(selected_rooms, key) > 1 }">
                                            <div class="text-lg font-semibold select-none">
                                                {{ getLocaleRoomName(JSON.parse(rooms)[key], $i18n.locale.toUpperCase()) }}
                                            </div>
                                            <div v-if="getOccurrence(selected_rooms, key) > 1"
                                                class="text-xs primary_color h-5">
                                                {{ $t('Divided over ') }} {{ getOccurrence(selected_rooms, key) }} {{
                                                    $tc('room',
                                                        getOccurrence(selected_rooms, key)) }}
                                            </div>
                                            <div v-else class="h-5">
                                            </div>
                                        </div>
                                        <div v-for="(item, index) in assigned_temp[key]"
                                            class="w-full items-center justify-between flex-col px-4 py-2">
                                            <div class="w-full border rounded-lg">
                                                <div
                                                    class="text-lg font-semibold price p-5 select-none flex justify-between w-full items-center">
                                                    <div class="text-medium">
                                                        {{ $t('Adults') }}
                                                    </div>
                                                    <div class="custom-number-input h-10 w-32">
                                                        <div
                                                            class="flex flex-row h-10 w-full rounded-lg relative bg-transparent">
                                                            <button @click.prevent="decrementAdult(key, index)"
                                                                class=" bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-l cursor-pointer outline-none select-none"
                                                                :class="{
                                                                    'opacity-50 bg-gray-100 pointer-events-none cursor-not-allowed ': parseInt(assigned_temp[key][index][0]) < 2
                                                                }">
                                                                <span class="m-auto text-2xl font-thin">−</span>
                                                            </button>
                                                            <input type="number" readonly
                                                                class="outline-none focus:ring-0 select-none border-none focus:outline-none text-center w-full bg-gray-200 font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none"
                                                                name="custom-input-number"
                                                                :value="assigned_temp[key][index][0]" />
                                                            <button @click.prevent="incrementAdult(key, index)"
                                                                class="bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-r cursor-pointer select-none"
                                                                :class="{
                                                                    'opacity-50 bg-gray-100 pointer-events-none cursor-not-allowed ': JSON.parse(rooms)[key].maxPeople == parseInt(assigned_temp[key][index][1]) + parseInt(assigned_temp[key][index][0])
                                                                }">
                                                                <span class="m-auto text-2xl font-thin">+</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="JSON.parse(rooms)[key].maxPeople > 1" class="text-lg  price p-5 select-none flex justify-between w-full">
                                                    <div class="text-medium flex flex-col font-semibold -mt-2">
                                                        {{ $t('Children') }}
                                                        <small class="text-xs font-normal">{{ $t('3 - 17 years old')
                                                        }}</small>
                                                    </div>
                                                    <div class="custom-number-input h-10 w-32">
                                                        <div
                                                            class="flex flex-row h-10 w-full rounded-lg relative bg-transparent">
                                                            <button @click.prevent="decrementChild(key, index)"
                                                                class=" bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-l cursor-pointer outline-none select-none"
                                                                :class="{
                                                                        'opacity-50 bg-gray-100 pointer-events-none cursor-not-allowed ': parseInt(assigned_temp[key][index][1]) == 0
                                                                    }">
                                                                <span class="m-auto text-2xl font-thin">−</span>
                                                            </button>
                                                            <input type="number" readonly
                                                                class="outline-none focus:ring-0 select-none border-none focus:outline-none text-center w-full bg-gray-200 font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none"
                                                                name="custom-input-number"
                                                                :value="assigned_temp[key][index][1]" />
                                                            <button @click.prevent="incrementChild(key, index)"
                                                                class="bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-r cursor-pointer select-none"
                                                                :class="{ 'opacity-50 bg-gray-100 pointer-events-none cursor-not-allowed ': JSON.parse(rooms)[key].maxPeople == parseInt(assigned_temp[key][index][0]) + parseInt(assigned_temp[key][index][1]) }">
                                                                <span class="m-auto text-2xl font-thin">+</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="flex items-center justify-between p-6 space-x-2 border-t border-gray-200 rounded-b">

                    <button type="button" data-modal-hide="guestSetupModal" @click="reset"
                        class="text-gray-500 bg-white duration-300 transition hover:scale-105 hover:shadow-lg focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
                        {{ $t('Cancel') }}</button>
                    <button type="button" @click.prevent="getNewSetup"
                        class="text-white primary_background duration-300 transition hover:scale-105 hover:shadow-lg focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                        {{ $t('Change setup') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCookies from 'vue-cookies'

import RoomHelpers from "../roomhelpers";

export default {

    props: ['rooms', 'selected_rooms', 'assigned_people', 'num_adult', 'num_children'],
    data() {
        return {
            num_adult_temp: this.num_adult,
            num_children_temp: this.num_children,
            assigned_temp: _.cloneDeep(this.assigned_people),
            total_assigned_adult: 0,
            total_assigned_children: 0,
            new_assignment: []
        };
    },
    methods: {
        ...RoomHelpers,
        incrementAdult: function (key, index) {
            this.new_assignment = _.cloneDeep(this.assigned_temp)
            var newValue = [parseInt(this.assigned_temp[key][index][0]) + 1, parseInt(this.assigned_temp[key][index][1])]
            this.new_assignment[key][index] = newValue
            this.assigned_temp = this.new_assignment;
            this.num_adult_temp = parseInt(this.num_adult_temp) + 1
        },
        decrementAdult: function (key, index) {
            if (this.assigned_temp[key][index][0] > 0) {
                this.new_assignment = _.cloneDeep(this.assigned_temp)
                var newValue = [parseInt(this.assigned_temp[key][index][0]) - 1, parseInt(this.assigned_temp[key][index][1])]
                this.new_assignment[key][index] = newValue
                this.assigned_temp = this.new_assignment;
                this.num_adult_temp = parseInt(this.num_adult_temp) - 1
            }
        },
        incrementChild: function (key, index) {
            this.new_assignment = _.cloneDeep(this.assigned_temp)
            var newValue = [parseInt(this.assigned_temp[key][index][0]), parseInt(this.assigned_temp[key][index][1]) + 1]
            this.new_assignment[key][index] = newValue
            this.assigned_temp = this.new_assignment;
            this.num_children_temp = parseInt(this.num_children_temp) + 1
        },
        decrementChild: function (key, index) {
            if (this.assigned_temp[key][index][1] > 0) {
                this.new_assignment = _.cloneDeep(this.assigned_temp)
                var newValue = [parseInt(this.assigned_temp[key][index][0]), parseInt(this.assigned_temp[key][index][1]) - 1]
                this.new_assignment[key][index] = newValue
                this.assigned_temp = this.new_assignment;
                this.num_children_temp = parseInt(this.num_children_temp) - 1
            }
        },
        calculateAssigned() {
            this.total_assigned_adult = 0;
            this.total_assigned_children = 0;
            for (var i in this.assigned_temp) {
                for (var j in this.assigned_temp[i]) {
                    this.total_assigned_adult += this.assigned_temp[i][j][0]
                    this.total_assigned_children += this.assigned_temp[i][j][1]
                }
            }
        },
        reset() {
            this.num_adult_temp = this.num_adult,
                this.num_children_temp = this.num_children,
                this.assigned_temp = _.cloneDeep(this.assigned_people),
                this.total_assigned_adult = 0,
                this.total_assigned_children = 0,
                this.new_assignment = []
        },
        getNewSetup() {
            history.replaceState(null, null, ' ');
            var urlString = window.location.href;
            var url = new URL(urlString);
            var roomstring = []
            for (var i in this.assigned_temp) {
                roomstring.push(i + "_" + this.getOccurrence(this.selected_rooms, i) + "_" + this.assigned_temp[i].join("-"))
            }
            const newParams = {
                setup: roomstring.join("."),
                numAdult: this.num_adult_temp,
                numChildren: this.num_children_temp,
            };
            Object.keys(newParams).forEach(key => {
                url.searchParams.set(key, newParams[key]);
            });
            window.location.href = decodeURIComponent(url);
        }
    },
    watch: {
        assigned_people: function () {
            this.assigned_temp = _.cloneDeep(this.assigned_people)
        },
        assigned_temp: {
            handler: function () {
                this.calculateAssigned()
            },
            deep: true
        }
    },
    created() {
        this.calculateAssigned()
    }
}
</script>